export default "__VITE_ASSET__vl4ZHaMr__"